import { render, staticRenderFns } from "./PcBoard.vue?vue&type=template&id=8012a548&scoped=true"
import script from "./PcBoard.vue?vue&type=script&lang=ts"
export * from "./PcBoard.vue?vue&type=script&lang=ts"
import style0 from "./PcBoard.vue?vue&type=style&index=0&id=8012a548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8012a548",
  null
  
)

export default component.exports